import styles from './ShippingInfo.module.scss'

import React from 'react'

import { useSkuBasesOrVariantsShippingData } from 'Contexts/UserSpecificProductDataStore/UserSpecificProductDataStore'

import Svg from 'Atoms/Svg'
import Typography from 'Atoms/Typography'

const ShippingInfo = ({ skuBaseNumber, className }) => {
  const shipping = useSkuBasesOrVariantsShippingData(skuBaseNumber)

  if (shipping == false) {
    return false
  }

  if (!shipping) {
    return <div style={{ minHeight: '91px' }}></div>
  }

  return (
    <>
      <div className={className}>
        <div className={styles.shippingInfo}>
          {shipping?.shippingDetailsString ? (
            <Typography size={0.875} className={styles.shippingRow} tone={'subtle'}>
              <Svg className={styles.shippingIcon} icon={shipping.detailsIcon} size={1.25} />
              {shipping.shippingDetailsString}
            </Typography>
          ) : undefined}
          {shipping?.dateString ? (
            <span className={shipping?.detailsIcon ? styles.shipping : null}>
              {shipping.labelText && (
                <Typography size={0.875} tone={'subtle'} inline>
                  {shipping.labelText + ' '}
                </Typography>
              )}
              {shipping.dateString && (
                <Typography size={0.875} font={'bold'} inline>
                  {shipping.dateString}
                </Typography>
              )}
            </span>
          ) : undefined}

          {shipping?.suggestedPickup ? (
            <>
              <Typography size={0.875} className={styles.shippingPickupRow} tone={'subtle'}>
                <Svg className={styles.shippingIcon} icon={'in_store_pickup'} size={1} />
                {shipping.suggestedPickup}
              </Typography>
            </>
          ) : undefined}
        </div>
      </div>
    </>
  )
}

export default ShippingInfo
